<template>
    <div>
        <div class="" v-for="info in benefit_infos">
            <div class="benefit-img">
                <img class="benefit" :src="info.benefit_path" />
            </div>
            <div class="download">
                <a :href="info.benefit_path" class="btn btn-dark button">{{ characters.download }}</a>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "show-benefit-content",
        props: ['order_id', 'benefit_id', 'json_characters'],
        data: function () {
            return {
                benefit_infos: [],
                characters: Object,
                submitable: false,
            }
        },
        mounted() {
            this.characters = JSON.parse(this.json_characters);
            axios.default
                .post('/benefit/content/get', {
                    order_id: this.order_id,
                    benefit_id: this.benefit_id,
                })
                .then(response => {
                    this.benefit_infos = response.data;
                    if(!this.benefit_infos.length) {
                        alert(this.characters.parameter_strange);
                    }
                });
        },

    }
</script>

<style scoped>
</style>
